import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { IconButton, Grid, Card, Tooltip } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import { DeleteIcon } from "@icarius-icons";
import Form from "./form";
import { deleteRetirementDefinitionAction } from "../../actions";
import DataContainer from "@icarius-common/abmComponents/dataContainer";
import { openDialogAction } from "@icarius-common/dialog/actions";
import { formatNumberExactDecimals } from "@icarius-utils/format";
import useIsSocietyCountry from "@icarius-app/components/wrapper/hooks/useIsSocietyCountry";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";

const DataItem = (props) => {
    const { data, closeNew } = props;
    const dispatch = useDispatch();

    const isCreate = !Boolean(data);
    const color = useSelector(getAppColor);
    const isChile = useIsSocietyCountry("CL");
    const isPeru = useIsSocietyCountry("PE");

    const [isOpen, setIsOpen] = useState(isCreate); //si viene sin data, que este abierto por defecto

    const handleDeletePublication = () => {
        if (isCreate) {
            closeNew();
        } else {
            dispatch(deleteRetirementDefinitionAction(data));
        }
    };

    const handleClosePublication = () => {
        Boolean(data) && setIsOpen((prev) => !prev);
    };

    const formatDecimal = (value) => {
        if (!value && value !== 0) return;

        return formatNumberExactDecimals(Number(value), 2);
    };

    // En la card de alta este boton no borra nada: handleDeletePublication cae en
    // closeNew() y descarta lo tipeado sin crear. El dialogo igual decia "borrar",
    // que es enganoso, asi que en alta se confirma como cancelacion.
    const handleOpenDeleteDialog = () => {
        dispatch(
            openDialogAction({
                title: isCreate ? getLocalizedString("cancel") : getLocalizedString("deletePensionInstitution"),
                msg: isCreate
                    ? getLocalizedString("unsavedChangesConfirmation")
                    : getLocalizedString("doYouWantToDeleteThePreventionInstitution"),
                onConfirm: handleDeletePublication,
            })
        );
    };

    return (
        <>
            <Card
                style={{
                    width: "100%",
                    borderRadius: 10,
                    background: isOpen || isCreate ? color : "",
                    color: (isOpen || isCreate) && "white",
                }}
            >
                <Grid container item xs={12} direction="row" style={{ padding: "10px 20px" }}>
                    <Grid
                        container
                        item
                        xs={11}
                        style={{ cursor: Boolean(data) ? "pointer" : "" }}
                        onClick={handleClosePublication}
                    >
                        {isCreate ? (
                            <DataContainer lg={12} sm={12} md={12} text={getLocalizedString("createProvision")} />
                        ) : (
                            <>
                                <DataContainer xs={12} sm={6} md={2} lg={1} text={data.code} />
                                <DataContainer xs={12} sm={6} md={2} lg={3} text={data.name} />
                                <DataContainer
                                    xs={12}
                                    sm={6}
                                    md={2}
                                    lg={2}
                                    text={`${getLocalizedString("mandatory")}: ${formatDecimal(
                                        data.mandatoryPercentage
                                    ) || "-"}`}
                                />
                                <DataContainer
                                    xs={12}
                                    sm={6}
                                    md={2}
                                    lg={2}
                                    text={`${getLocalizedString("insurance")}: ${formatDecimal(
                                        data.disabilityInsurance
                                    ) || "-"}`}
                                />
                                <DataContainer
                                    xs={12}
                                    sm={6}
                                    md={2}
                                    lg={2}
                                    text={`${getLocalizedString("commission")}: ${formatDecimal(
                                        data.retirementPercentage
                                    ) || "-"}`}
                                />
                                {isChile && (
                                    <DataContainer
                                        xs={12}
                                        sm={6}
                                        md={2}
                                        lg={2}
                                        text={`Previred: ${data.previredCode}`}
                                    />
                                )}
                                {isPeru && (
                                    <DataContainer
                                        xs={12}
                                        sm={6}
                                        md={2}
                                        lg={2}
                                        text={`${getLocalizedString("afpCode")}: ${data.afpCode || "-"}`}
                                    />
                                )}
                            </>
                        )}
                    </Grid>
                    <Grid container direction="row" item xs={1} justify="center">
                        <Tooltip title={getLocalizedString("delete")}>
                            <IconButton size={"small"} disableRipple onClick={handleOpenDeleteDialog}>
                                <DeleteIcon style={{ fill: "var(--mainText)" }} fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Card>
            {isOpen && <Form data={data} handleClose={isCreate ? closeNew : handleClosePublication} />}
        </>
    );
};

export default DataItem;
